module.exports = __webpack_public_path__ + "static/media/undraw-credit-card-2x.8004b734.png";